import defaultModeTemplate from 'text!./templates/name-details-default.html';
import japanModeTemplate from 'text!./templates/name-details-JP.html';

export default ['LocaleService', function (LocaleService) {
    var defaultHiddenFields = ['Prefix', 'Suffix', 'MiddleName', 'Particle'];
    var nameConfig = LocaleService.getNameConfig();

    return {
        restrict: 'A',
        template: nameConfig.mode === 'Japan' ? japanModeTemplate : defaultModeTemplate,
        scope: {
            contact: '=', // if this val is changed in view then it changes in the model
            readonly: '=', // if this val is changed in view it DOES NOT change in the model
            nameLabelPrefix: '@',
            firstnamePlaceholder: '@',
            placeholders: '=?'
        },

        link: function link(scope) {
            scope.hiddenFields = defaultHiddenFields;
            scope.nameLabelPrefix = scope.nameLabelPrefix || 'platform.inputs.contact-details.';
            scope.isFieldVisible = function (fieldName) {
                var visible = nameConfig.visibleFields.indexOf(fieldName) >= 0;
                var hidden = scope.hiddenFields.indexOf(fieldName) >= 0;
                return visible && !hidden;
            };
        }

    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/platform/widgets/inputs/NameDetails.js
// module id = 778
// module chunks = 0